export const employee = (state) => state.employee
export const showDialog = (state) => state.showDialog